import clsx from "clsx";

import type { IconSvg } from "@/types/IconSvg";

/**
 * Rend une icone deja resolue en `<svg>` inline.
 *
 * Volontairement sans `'use client'` : le composant n'a ni etat ni effet, il est
 * donc rendu sur le serveur quand son parent l'est (`About`, `SocialMedia`) et
 * compile dans le bundle client quand son parent est client (`FlyMenu`). Dans
 * les deux cas il n'embarque aucun code FontAwesome — la resolution du nom se
 * fait en amont, cote serveur (cf. `@/utilities/resolveIcons`).
 *
 * La feuille de style de FontAwesome n'a jamais ete chargee par cette app : le
 * dimensionnement venait deja entierement des classes passees par l'appelant,
 * que l'on continue d'appliquer telles quelles.
 */
export const Icon: React.FC<{
  icon?: IconSvg | null;
  className?: string | null;
}> = ({ icon, className }) => {
  if (!icon) return null;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${icon.width} ${icon.height}`}
      role="img"
      aria-hidden="true"
      focusable="false"
      className={clsx(className)}
    >
      <path fill="currentColor" d={icon.path} />
    </svg>
  );
};
